var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-bottom": "20px" },
          attrs: { data: _vm.data2, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "lastNodeName",
              label: "工艺类型及名称",
              width: "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.lastNodeName === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.lastNodeName) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "processPlantName", label: "供应商" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.processPlantName === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(
                            " " + _vm._s(scope.row.processPlantName) + " "
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "实际供应商" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.secondarySupplierName === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(
                            " " + _vm._s(scope.row.secondarySupplierName) + " "
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "temporaryFabricCodingName",
              label: "对应物料信息",
              width: "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.temporaryFabricCodingName === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.temporaryFabricCodingName) +
                              " "
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "actualConsumption", label: "单件用量" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.actualConsumption === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(
                            " " + _vm._s(scope.row.actualConsumption) + " "
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "pricingUnitPrice",
              label: "单价（元）",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.pricingUnitPrice === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(
                            " " + _vm._s(scope.row.pricingUnitPrice) + " "
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "priceAssessmentAmount",
              label: "金额（元）",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.priceAssessmentAmount === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(
                            " " + _vm._s(scope.row.priceAssessmentAmount) + " "
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "usedPartName", label: "使用部位", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.usedPartName === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.usedPartName) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "materialImage", label: "图片" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-image", {
                      staticStyle: { width: "40px" },
                      attrs: {
                        src: _vm._f("picFilter")(scope.row.materialImage, {
                          size: "large",
                        }),
                        "preview-src-list": [scope.row.materialImage],
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "remark", label: "工艺要求描述" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.remark === null
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(" " + _vm._s(scope.row.remark) + " "),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "加工金额", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _c("span", [_vm._v("加工单价(元):")]),
                      _vm._v(" "),
                      scope.row.purchasePrice === null
                        ? _c("span", [_vm._v(" - ")])
                        : _c("span", [_vm._v(_vm._s(scope.row.purchasePrice))]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v("加工总量(米):")]),
                      _vm._v(" "),
                      scope.row.processQty === null
                        ? _c("span", [_vm._v(" - ")])
                        : _c("span", [_vm._v(_vm._s(scope.row.processQty))]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v("加工总额(元):")]),
                      _vm._v(" "),
                      scope.row.purchaseAmount === null
                        ? _c("span", [_vm._v(" - ")])
                        : _c("span", [
                            _vm._v(_vm._s(scope.row.purchaseAmount)),
                          ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "工艺信息", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _c("span", [_vm._v("加工件/米:")]),
                      _vm._v(" "),
                      scope.row.processQty === null
                        ? _c("span", [_vm._v(" - ")])
                        : _c("span", [_vm._v(_vm._s(scope.row.processQty))]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v("预估件数:")]),
                      _vm._v(" "),
                      scope.row.estimateQty === null
                        ? _c("span", [_vm._v(" - ")])
                        : _c("span", [_vm._v(_vm._s(scope.row.estimateQty))]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v("订单件数:")]),
                      _vm._v(" "),
                      scope.row.orderQty === null
                        ? _c("span", [_vm._v(" - ")])
                        : _c("span", [_vm._v(_vm._s(scope.row.orderQty))]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v("差异件数:")]),
                      _vm._v(" "),
                      scope.row.differenceQty === null
                        ? _c("span", [_vm._v(" - ")])
                        : _c("span", [_vm._v(_vm._s(scope.row.differenceQty))]),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }